import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

const createStyleSearchFilter =
  (filterType: string, searchParam: string) =>
  ({ vars }: { vars?: string[] }) =>
    api.get(
      stringParse(
        `/api/organizations/{1}/purchase-orders/{2}/styles/facility-processes?forfilter=${filterType}&${searchParam}={0}&organizationId={4}`,
        vars?.length === 5 ? ['', ...vars] : vars
      )
    );

export const apiMeta: ApiType = {
  get: {
    filtersSubSuppliers: () => api.get('/api/meta/filters/sub-suppliers'),
    searchSubSuppliersName: ({ vars }) =>
      api.get(stringParse('/api/meta/search/sub-suppliers/?name={0}', vars)),

    searchSubSuppliersCustomId: ({ vars }) =>
      api.get(stringParse('/api/meta/search/sub-suppliers/?customId={0}', vars)),

    searchSubSuppliersPrimaryContact: ({ vars }) =>
      api.get(stringParse('/api/meta/search/sub-suppliers/?primaryContact={0}', vars)),

    filtersWorkflowTasks: () => api.get('/api/meta/filters/workflow-tasks'),
    filtersTaskLinks: ({ vars }) => api.get(stringParse('/api/meta/filters/task-links/{0}', vars)),
    filtersTasks: () => api.get('/api/meta/filters/tasks'),
    filtersFacilities: ({ vars }) => api.get(stringParse('/api/meta/filters/{0}/facility', vars)),
    searchFacilities: () => api.get('/api/meta/search/facilities'),
    filtersStyles: ({ vars }) =>
      api.get(stringParse('/api/meta/filters/styles?publishedAt={2}', vars)),
    filtersStylesForPoMapping: ({ vars }) =>
      api.get(stringParse('/api/meta/filters/styles?publishedAt={2}&designerOrgId={4}', vars)),
    filtersStylesCustomfields: ({ vars }) =>
      api.get(stringParse('api/meta/filters/styles/customfields?publishedAt={1}', vars)),
    getStylesCustomFieldsMeta: ({ vars }) =>
      api.get(stringParse('/api/meta/styles/custom-fields?publishedAt={1}', vars)),
    filtersStylesNameSearch: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/styles/?forfilter=true&supplierOrganizationId={2}&stylenamesearch={0}',
          vars?.length === 2 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNumberSearch: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/styles/?forfilter=true&supplierOrganizationId={2}&stylenumbersearch={0}',
          vars?.length === 2 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNameSearchForPO: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{4}/styles/?forfilter=stylename&styleNameSearch={0}',
          vars?.length === 4 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNumberSearchForPO: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{4}/styles/?forfilter=stylenumber&styleNumberSearch={0}',
          vars?.length === 4 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNameSearchSupplier: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{4}/styles/contents?type=facilities&forfilter=stylename&styleNameSearch={0}&organizationId={5}',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNumberSearchSupplier: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{4}/styles/contents?type=facilities&forfilter=stylenumber&styleNumberSearch={0}&organizationId={5}',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNameSearchSupplierCertificates: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{4}/styles/contents?type=certificates&forfilter=stylename&styleNameSearch={0}&organizationId={5}',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      ),
    filtersStylesNumberSearchSupplierCertificates: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{4}/styles/contents?type=certificates&forfilter=stylenumber&styleNumberSearch={0}&organizationId={5}',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      ),
    filtersItems: ({ vars }) =>
      api.get(stringParse('/api/meta/filters/items/?publishedAt={2}', vars)),
    filtersItemsForPoMapping: ({ vars }) =>
      api.get(stringParse('/api/meta/filters/items/?publishedAt={2}&designerOrgId={3}', vars)),
    filtersItemsNameSearch: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/items/?forfilter=itemname&itemNameSearch={0}&styleIds={2}&status=Active',
          vars?.length === 2 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNumberSearch: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/items/?forfilter=itemnumber&itemNumberSearch={0}&styleIds={2}&status=Active',
          vars?.length === 2 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNameSearchForPO: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/items/?forfilter=itemname&itemNameSearch={0}&status=Active',
          vars?.length === 3 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNumberSearchForPO: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/items/?forfilter=itemnumber&itemNumberSearch={0}&status=Active',
          vars?.length === 3 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNameSearchForPOMapping: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/items/contents?type=facilities&forfilter=itemname&itemNameSearch={0}&organizationId={4}&status=Active',
          vars?.length === 4 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNumberSearchForPOMapping: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/items/contents?type=facilities&forfilter=itemnumber&itemNumberSearch={0}&organizationId={4}&status=Active',
          vars?.length === 4 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNameSearchForPOReviewAndApproval: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/items/facility-processes?forfilter=itemname&itemNameSearch={0}&organizationId={4}&status=Active',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      ),
    filtersItemsNumberSearchForPOReviewAndApproval: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/items/facility-processes?forfilter=itemnumber&itemNumberSearch={0}&organizationId={4}&status=Active',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      ),
    listItemSupplier: ({ vars }) =>
      api.get(
        stringParse(
          '/api/suppliers?isActive=true&isItemSupplier=true&search={0}&revisionTimestamp={3}',
          vars?.length === 3 ? ['', ...vars] : vars
        )
      ),
    listStyleSupplier: ({ vars }) =>
      api.get(stringParse('/api/suppliers?isStyleSupplier=true&search={0}', vars)),
    /**
     * Shared by PO filter dropdowns and the supplier Brands connected table.
     * Filter UIs bind search in vars[0]; the brands table passes pagination/sort/search via `query`
     * and only forsupplierUserId in vars (length 1 → prepended as ['', userId]).
     */
    listBrandCompanies: ({ query, vars }) =>
      api.get(
        stringParse(
          '/api/organizations/brand-companies?forsupplierUserId={1}&search={0}',
          vars?.length === 1 ? ['', ...vars] : vars
        ),
        query
      ),
    listPoStates: () => api.get('/api/postates'),
    listSubSuppliers: ({ vars }) => {
      return api.get(
        stringParse(
          '/api/organizations/{1}/purchase-orders/{2}/sub-suppliers?podesignerorganizationid={4}&forfilter=1&submitedForApprovalAt={5}',
          vars?.length === 5 ? ['', ...vars] : vars
        )
      );
    },
    filtersStylesNameSearchPOReviewApproval: ({ vars }) =>
      createStyleSearchFilter('stylename', 'styleNameSearch')({ vars }),
    filtersStylesNumberSearchPOReviewApproval: ({ vars }) =>
      createStyleSearchFilter('stylenumber', 'styleNumberSearch')({ vars }),
    filtersApprovedBySearchPOReviewApproval: ({ vars }) =>
      api.get(
        stringParse('/api/organizations/{1}/users', vars?.length === 5 ? ['', ...vars] : vars)
      ),
    filtersStylesProcessTypePOReviewApproval: () => api.get(stringParse('api/facilityprocesstype')),
    certificateStandards: ({ vars }) =>
      api.get(stringParse('/api/scm-certificate-standards?certificateType={0}', vars)),
    certificateInstitutes: () => api.get('/api/scm-certificate-institutes'),
    facilitiesListforDirectSupplier: ({ vars }) =>
      api.get(
        stringParse(
          '/api/organizations/{1}/suppliers/{2}/facilities?search={0}',
          vars?.length === 2 ? ['', ...vars] : vars
        )
      ),
  },
  post: {},
  put: {},
  delete: {},
};

/** Sub-supplier filter/search APIs scoped by organizationId for the direct-supplier sub-suppliers tab. */
export const directSupplierSubSuppliersApi = {
  filtersSubSuppliers: (organizationId: string) => () =>
    api.get(`/api/meta/filters/sub-suppliers?organizationId=${organizationId}`),
  filtersSubSuppliersPrimaryContact:
    (organizationId: string) =>
    ({ vars }: { vars?: string[] }) =>
      api.get(
        stringParse(
          `/api/meta/search/sub-suppliers/?primaryContact={0}&organizationId=${organizationId}`,
          vars
        )
      ),
  filtersSubSuppliersCustomId:
    (organizationId: string) =>
    ({ vars }: { vars?: string[] }) =>
      api.get(
        stringParse(
          `/api/meta/search/sub-suppliers/?customId={0}&organizationId=${organizationId}`,
          vars
        )
      ),
  searchSubSuppliersName:
    (organizationId: string) =>
    ({ vars }: { vars?: string[] }) =>
      api.get(
        stringParse(
          `/api/meta/search/sub-suppliers/?name={0}&organizationId=${organizationId}`,
          vars
        )
      ),
};
